import { Power } from "lucide-react";
import DarkModeBtn from "../buttons/dark-mode";
import LanguageSelect from "./language-select";
import { Button } from "../ui/button";
import Link from "next/link";
import useAuthStore from "~/stores/auth";

const InterfaceControls = () => {
	const user = useAuthStore((state) => state.user);

	return (
		<div className="absolute top-0 flex items-center justify-between gap-2 w-full p-2">
			<div className="flex items-center gap-2"></div>
			<div className="flex items-center gap-2">
				<DarkModeBtn />
				<LanguageSelect />
				{user && (
					<Link href="/auth/logout">
						<Button
							variant="outline"
							size="icon"
							className="text-destructive border-destructive/60"
						>
							<Power size="18" />
						</Button>
					</Link>
				)}
			</div>
		</div>
	);
};

export default InterfaceControls;
